import "core-js/modules/esnext.string.match-all.js";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _setPrototypeOf from "@babel/runtime/helpers/esm/setPrototypeOf";
const _excluded = ["format"];
import "core-js/modules/esnext.string.match-all.js";
function _wrapRegExp() {
  _wrapRegExp = function (e, r) {
    return new BabelRegExp(e, void 0, r);
  };
  var e = RegExp.prototype,
    r = new WeakMap();
  function BabelRegExp(e, t, p) {
    var o = new RegExp(e, t);
    return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype);
  }
  function buildGroups(e, t) {
    var p = r.get(t);
    return Object.keys(p).reduce(function (r, t) {
      var o = p[t];
      if ("number" == typeof o) r[t] = e[o];else {
        for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++;
        r[t] = e[o[i]];
      }
      return r;
    }, Object.create(null));
  }
  return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) {
    var t = e.exec.call(this, r);
    if (t) {
      t.groups = buildGroups(t, this);
      var p = t.indices;
      p && (p.groups = buildGroups(p, this));
    }
    return t;
  }, BabelRegExp.prototype[Symbol.replace] = function (t, p) {
    if ("string" == typeof p) {
      var o = r.get(this);
      return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function (e, r) {
        var t = o[r];
        return "$" + (Array.isArray(t) ? t.join("$") : t);
      }));
    }
    if ("function" == typeof p) {
      var i = this;
      return e[Symbol.replace].call(this, t, function () {
        var e = arguments;
        return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e);
      });
    }
    return e[Symbol.replace].call(this, t, p);
  }, _wrapRegExp.apply(this, arguments);
}
import { toUrl } from "../utils.js";
const uploadcareRegex = /*#__PURE__*/_wrapRegExp(/^https?:\/\/([^\/]+)\/([^\/]+)/g, {
  host: 1,
  uuid: 2
});
/**
 * Taken from uploadcare/blocks
 *
 * @see https://github.com/uploadcare/blocks/blob/87d1048e94f05f99e1da988c86c6362522e9a3c8/utils/cdn-utils.js#L57
 */
export function extractFilename(cdnUrl) {
  const url = new URL(cdnUrl);
  const noOrigin = url.pathname + url.search + url.hash;
  const urlFilenameIdx = noOrigin.lastIndexOf("http");
  const plainFilenameIdx = noOrigin.lastIndexOf("/");
  let filename = "";
  if (urlFilenameIdx >= 0) {
    filename = noOrigin.slice(urlFilenameIdx);
  } else if (plainFilenameIdx >= 0) {
    filename = noOrigin.slice(plainFilenameIdx + 1);
  }
  return filename;
}
/**
 * Taken from uploadcare/blocks
 *
 * @see https://github.com/uploadcare/blocks/blob/87d1048e94f05f99e1da988c86c6362522e9a3c8/utils/cdn-utils.js#L131
 */
export function isFileUrl(filename) {
  return filename.startsWith("http");
}
/**
 * Taken from uploadcare/blocks
 *
 * @see https://github.com/uploadcare/blocks/blob/87d1048e94f05f99e1da988c86c6362522e9a3c8/utils/cdn-utils.js#L141
 */
export function splitFileUrl(fileUrl) {
  const url = new URL(fileUrl);
  return {
    pathname: url.origin + url.pathname || "",
    search: url.search || "",
    hash: url.hash || ""
  };
}
/**
 * Taken from uploadcare/blocks
 *
 * @see https://github.com/uploadcare/blocks/blob/87d1048e94f05f99e1da988c86c6362522e9a3c8/utils/cdn-utils.js#L114
 */
export function trimFilename(cdnUrl) {
  const url = new URL(cdnUrl);
  const filename = extractFilename(cdnUrl);
  const filenamePathPart = isFileUrl(filename) ? splitFileUrl(filename).pathname : filename;
  url.pathname = url.pathname.replace(filenamePathPart, "");
  url.search = "";
  url.hash = "";
  return url.toString();
}
/**
 * Taken from uploadcare/blocks
 *
 * @see https://github.com/uploadcare/blocks/blob/87d1048e94f05f99e1da988c86c6362522e9a3c8/utils/cdn-utils.js#L9C1-L24C3
 */
export const normalizeCdnOperation = operation => {
  if (typeof operation !== "string" || !operation) {
    return "";
  }
  let str = operation.trim();
  if (str.startsWith("-/")) {
    str = str.slice(2);
  } else if (str.startsWith("/")) {
    str = str.slice(1);
  }
  if (str.endsWith("/")) {
    str = str.slice(0, str.length - 1);
  }
  return str;
};
/**
 * Taken from uploadcare/blocks
 *
 * @see https://github.com/uploadcare/blocks/blob/87d1048e94f05f99e1da988c86c6362522e9a3c8/utils/cdn-utils.js#L93C1-L106C2
 */
export function extractOperations(cdnUrl) {
  const withoutFilename = trimFilename(cdnUrl);
  const url = new URL(withoutFilename);
  const operationsMarker = url.pathname.indexOf("/-/");
  if (operationsMarker === -1) {
    return [];
  }
  const operationsStr = url.pathname.substring(operationsMarker);
  return operationsStr.split("/-/").filter(Boolean).map(operation => normalizeCdnOperation(operation));
}
const parseOperations = operations => {
  return operations.length ? operations.reduce((acc, operation) => {
    const [key, value] = operation.split("/");
    return Object.assign({}, acc, {
      [key]: value
    });
  }, {}) : {};
};
const formatUrl = _ref => {
  let {
    host,
    uuid,
    operations = {},
    filename
  } = _ref;
  const operationString = Object.entries(operations).map(_ref2 => {
    let [key, value] = _ref2;
    return key + "/" + value;
  }).join("/-/");
  const pathSegments = [host, uuid, operationString ? "-/" + operationString : "", filename].join("/");
  return "https://" + pathSegments;
};
export const parse = imageUrl => {
  const url = toUrl(imageUrl);
  const matchers = _toConsumableArray(url.toString().matchAll(uploadcareRegex));
  if (!matchers.length) {
    throw new Error("Invalid Uploadcare URL");
  }
  const group = matchers[0].groups || {};
  const baseParams = Object.assign({}, (_objectDestructuringEmpty(group), group));
  const filename = extractFilename(url.toString());
  const _parseOperations = parseOperations(extractOperations(url.toString())),
    {
      format: f
    } = _parseOperations,
    operations = _objectWithoutPropertiesLoose(_parseOperations, _excluded);
  const format = f && f !== "auto" ? f : "auto";
  const base = formatUrl(Object.assign({}, baseParams, {
    filename: filename || undefined,
    operations: Object.assign({}, operations, {
      format
    })
  }));
  return {
    base,
    cdn: "uploadcare",
    params: Object.assign({}, group, {
      filename: filename || undefined,
      operations: Object.assign({}, operations, {
        format
      })
    })
  };
};
export const generate = _ref3 => {
  let {
    base,
    width,
    height,
    params
  } = _ref3;
  const baseUrl = base.toString();
  const parsed = parse(baseUrl.endsWith("/") ? baseUrl : baseUrl + "/");
  const props = Object.assign({
    operations: {}
  }, parsed.params, params);
  if (width && height) {
    props.operations = Object.assign({}, props.operations, {
      resize: width + "x" + height
    });
  } else {
    if (width) {
      props.operations = Object.assign({}, props.operations, {
        resize: width + "x"
      });
    }
    if (height) {
      props.operations = Object.assign({}, props.operations, {
        resize: "x" + height
      });
    }
  }
  return formatUrl(props);
};
export const transform = _ref4 => {
  let {
    url: originalUrl,
    width,
    height
  } = _ref4;
  const parsed = parse(originalUrl);
  if (!parsed) {
    throw new Error("Invalid Uploadcare URL");
  }
  const props = Object.assign({}, parsed, {
    width,
    height
  });
  return generate(props);
};